import { up } from 'styled-breakpoints'
import styled from 'styled-components'

import theme from '~/truck/theme'

export const ContentContainer = styled.div`
  background-color: ${theme.colors.white};
  border-radius: ${theme.dimensions.borderRadius}px;
  display: flex;
  flex-direction: column;
  padding: ${theme.spacing.comfortable}px;
  width: 100%;

  ${up('lg')} {
    margin: ${theme.spacing.comfortable}px auto 0 auto;
    width: calc(100% - ${theme.spacing.cozy * 4}px);
  }
`

export const ProductReviewsHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${theme.spacing.relaxed}px;

  > span:last-of-type {
    cursor: pointer;
    width: fit-content;
  }
`
